import useSWR from "swr";
import { Box } from "@mui/material";
import { fetchData } from "../../../lib/dashboard/data";
import MarketWatchTopGainers from "../MarketWatchTopGainers";
import ValueChangeTopGainers from "./value-change/ValueChangeTopGainers";

const MarketWatchStocks = () => {
  const { data = [], isLoading } = useSWR("/stock-market/stock", fetchData);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "14px",
      }}
    >
      <MarketWatchTopGainers
        title="ورود پول حقیقی"
        data={data.money_flow || []}
        isLoading={isLoading}
        url={"money_flow"}
        unit={"میلیارد تومان"}
      />
      <MarketWatchTopGainers
        title="قدرت خرید حقیقی"
        data={data.buy_pressure || []}
        isLoading={isLoading}
        url={"buy_pressure"}
        unit={"واحد"}
      />
      <MarketWatchTopGainers
        title="خرید درشت حقیقی"
        data={data.buy_value || []}
        isLoading={isLoading}
        url={"buy_value"}
        unit={"میلیارد تومان"}
      />
      <MarketWatchTopGainers
        title="نسبت سفارش های خرید"
        data={data.buy_ratio || []}
        isLoading={isLoading}
        url={"buy_ratio"}
        unit={"برابر"}
      />
      <MarketWatchTopGainers
        title="نسبت سفارش های فروش"
        data={data.sell_ratio || []}
        isLoading={isLoading}
        url={"sell_ratio"}
        unit={"برابر"}
      />
      <ValueChangeTopGainers
        title="نسبت ارزش معاملات به میانگین ماهانه"
        data={data.value_change || []}
        isLoading={isLoading}
        url={"value_change"}
        unit={"میلیارد تومان"}
      />
    </Box>
  );
};

export default MarketWatchStocks;
